import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export default selector;

export const createLoaderSelector = createSelector(
  selector,
  store => get(store, 'isFetching', false),
);

export const errorCodeSelector = createSelector(
  selector,
  store => get(store, 'errorCode', 0),
);

export const payloadSelector = createSelector(
  selector,
  store => get(store, 'payload', 0),
);
